import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export function formatDate(value?: string | null, pattern = 'DD MMM YYYY'): string {
  if (!value) return '—'
  return dayjs(value).format(pattern)
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '—'
  return dayjs(value).format('DD MMM YYYY, HH:mm')
}

/**
 * Format a UTC ISO (or UTC-naive) timestamp in the user's local timezone.
 * Does not fall back to “now” for invalid/missing values.
 */
export function formatUtcToLocalDateTime(value?: string | null): string {
  if (!value) return '—'
  const trimmed = value.trim()
  if (!trimmed) return '—'
  const hasZone = /Z$/i.test(trimmed) || /[+-]\d{2}:?\d{2}$/.test(trimmed)
  const parsed = dayjs(hasZone ? trimmed : `${trimmed}Z`)
  if (!parsed.isValid()) return '—'
  return parsed.format('DD MMM YYYY, HH:mm')
}

export function formatRelative(value?: string | null): string {
  if (!value) return 'Never'
  return dayjs(value).fromNow()
}

export function formatMoney(value?: number | null, currency = 'PKR'): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

/** Numeric amount for table cells — currency/unit goes in the column header */
export function formatAmount(value?: number | null, fractionDigits = 2): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-PK', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)
}

/** Whole numbers for qty/pieces columns (header carries the unit) */
export function formatCount(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-PK', { maximumFractionDigits: 0 }).format(value)
}

export function getInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
}

export function fullName(firstName: string, lastName: string): string {
  return `${firstName} ${lastName}`.trim()
}

